const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/medication.ts';
import moment from 'moment/moment';
import { KISIM_TIME_FORMAT } from '@cistec/common_web/defs/generalDefs';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { LOAD_ORDERS } from '@cistec/common_web/actions/orderActions';

export function loadMedication(patnr: string) {
    const mindat = moment().startOf('day').format(KISIM_TIME_FORMAT);
    const maxdat = moment().endOf('day').format(KISIM_TIME_FORMAT);
    const meta = { patnr, mindat, maxdat, withHotspots: true };
    return createPatapiCall(LOAD_ORDERS, 'orders/medication', HttpMethod.GET, meta);
}
